/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const checkoutCartStyle = {
  paperContainer: {
    maxWidth: "550px",
  },
  paperHeading: {
    color: "primary.main",
    marginBottom: 0,
    textAlign: "center",
  },
  table: {
    marginTop: "1rem",
  },
  tableCell: {
    fontSize: "1rem",
    padding: "0 10px 0 0",
    borderBottom: "none",
  },
  tableCellValue: {
    fontSize: "1rem",
    padding: "0 !important",
    borderBottom: "none",
    textAlign: "right",
    fontWeight: 500,
  },
  taxHint: {
    fontSize: "0.8rem",
  },
  sealContainer: {},
  ssl: {
    marginTop: "1.25rem",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  highlightBox: {
    textAlign: "center",
  },
};

export default checkoutCartStyle;
